import  * as firebase from "firebase";

const firebaseConfig = {
    apiKey: "AIzaSyBSRPKnzOTeUWf2k-nbkNFrNM1pseZOtIc",
    authDomain: "mewesearcher.firebaseapp.com",
    projectId: "mewesearcher",
    storageBucket: "mewesearcher.appspot.com",
    messagingSenderId: "1087425751431",
    appId: "1:1087425751431:web:a4b772a94ed6fd0da2cb22",
    measurementId: "G-GRS9364WEP"
};

firebase.initializeApp(firebaseConfig)
firebase.firestore()
firebase.performance();
firebase.analytics()

export default firebase